import { render, staticRenderFns } from "./CustomServer.vue?vue&type=template&id=2a3c3cc1"
import script from "./CustomServer.vue?vue&type=script&lang=js"
export * from "./CustomServer.vue?vue&type=script&lang=js"
import style0 from "./CustomServer.vue?vue&type=style&index=0&id=2a3c3cc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports